if(document.querySelector('#deliveryDate') != null){
document.querySelector('#deliveryDate').flatpickr(
    {
        "disable": [
            function(date) {
                return (date.getDay() === 0 || date.getDay() === 6);
            }
        ],
        "locale": {
            "firstDayOfWeek": 1
        }
    }
);
}
document.onreadystatechange = (event) => {
    if (event.target.readyState === "complete") {
        document.querySelector('[loading-indicator]').classList.add('d-none');
        document.querySelector('[cart-page-content]').classList.remove('d-none');
    }
  };